import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { ThisMonthExpression } from 'igniteui-angular-core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company, ICompanyGroup } from 'src/model/company.model';
import { LoanScheme } from 'src/model/loanScheme.model';
import { CompanyService } from 'src/services/company.service';
import { FileService } from 'src/services/file.service';
import { ReportService } from 'src/services/report.service';

interface ReportItem {
	name: string;
	index: number;
}

@Component({
	selector: 'app-report-generator',
	templateUrl: './report-generator.component.html',
	styleUrls: ['./report-generator.component.scss'],
	standalone: false
})
export class ReportGeneratorComponent implements OnInit {
	protected enums = inject(Enums);
	private router = inject(Router);
	private restapi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);
	protected sharedService = inject(SharedService);
	private fileService = inject(FileService);
	private companyService = inject(CompanyService);

	loanSchemeList: LoanScheme[] = [];
	companyGroupList: ICompanyGroup[] = [];
	companyList: Company[] = [];
	reportList: Map<string, ReportItem[]>;
	startDate: Date = new Date();
	endDate: Date = new Date();

	// myControl = new FormControl('');
	// filteredCompany: Observable<Company[]>;
	filteredCompany: Company[];

	disabledSubmitDL = false;
	@Output() sendCompanyData = new EventEmitter<any>();

	// primayReportList = ["Cash Book", "List Hutang", "Stock"];
	// otherReportList = ["Stamp Report", "S/C Report", "Duit Lebih Report", "Asset Report", "Hutang", "Simpan Report", "Commission Report"];

	@Input() selectedCompany: number;
	@Input() selectedReport: number;
	@Input() selectedCompanyGroup = 0;
	isCollapsed = false;
	isReady = false;
	isAll = false;
	companyDisabled = false;
	loggedInRole: number;

	// selectedCompanyCode: string;

	constructor() {
		this.loggedInRole = Number(sessionStorage.getItem('roleId'));
	}

	ngOnInit(): void {
		//default the start data always the beginning of the month
		this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
		this.endDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
		this.constructReportList();
		if (this.sharedService.isMonitoringUser()) {
			this.getAllGroups();
			this.getAllCompanies(this.selectedCompanyGroup ?? 0);
		} else this.selectedCompany = Number(sessionStorage.getItem('companyId'));
	}

	selectToday(picker: MatDatepicker<Date>) {
		picker.select(new Date());
		picker.close();
	}

	constructReportList() {
		let i = 1;
		const allReport = this.enums.reportString.map(r => ({ index: i++, name: r }));
		this.reportList = new Map<string, ReportItem[]>();
		this.reportList.set('Primary Report', allReport.slice(0, 5));
		this.reportList.set('Other Report', allReport.slice(5, 24));
		if (this.sharedService.isRoles([this.enums.ADMIN, this.enums.BOSS, this.enums.FINANCE])) this.reportList.set('Admin Report', allReport.slice(24, 27));
		if (this.sharedService.isRoles([this.enums.BOSS, this.enums.FINANCE])) this.reportList.set('Boss Only Report', allReport.slice(27));
	}

	get reports() {
		return Array.from(this.reportList.entries()).map(([key, value]) => ({ key, value }));
	}

	filterOptions(value: string) {
		const filterValue = value.toLowerCase();
		this.filteredCompany = this.companyList.filter(company => company.CompanyCode.toLowerCase().includes(filterValue));
	}

	displayCompanyCode = (id: number): string => {
		const comp = this.companyList.find(c => c.ID === id);
		return comp ? comp.CompanyCode : '';
	};

	resetReady() {
		this.isReady = false;
		this.isAll = false;

		if (this.selectedReport == this.enums.ASSET_SUMMARY_REPORT) {
			this.selectedCompany = undefined;
			this.companyDisabled = true;
		} else this.companyDisabled = false;
	}

	async getAllCompanies(companyGroup: number) {
		this.companyList.length = 0;
		this.companyList = await this.companyService.getAllCompanies({ groupId: companyGroup });
		this.filteredCompany = this.companyList;

		if (!this.companyList.some(c => c.ID === this.selectedCompany)) {
			this.selectedCompany = undefined;
		}
	}

	getAllLoanSchemes() {
		const xhttp = this.restapi.getRequest(this.constructApi.getAllLoanSchemes());
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);
				// console.log(jsonArray);

				jsonArray.forEach(json => {
					const loanScheme = new LoanScheme(json.id, json.name, json.term, json.interest);
					this.loanSchemeList.push(loanScheme);
				});
			}
		};
	}

	async getAllGroups() {
		this.companyGroupList = await this.companyService.getAllCompanyGroups();
	}

	includesReport(reports: number[]): boolean {
		return reports.includes(Number(this.selectedReport));
	}

	allowViewAll() {
		return this.includesReport([this.enums.STOCK, this.enums.CASH_BOOK, this.enums.HUTANG_REPORT, this.enums.LIST_HUTANG, this.enums.SIMPAN_REPORT]);
	}

	checkPass() {
		if (this.selectedReport == this.enums.ASSET_SUMMARY_REPORT || this.selectedReport == this.enums.STAMP_HQ_SUMMARY) {
			if (this.selectedCompanyGroup == 0) {
				this.sharedService.openAlert('Please select either 1 company group', ALERT_TYPE.DANGER);
				return false;
			}
			return true;
		} else if (
			this.selectedReport == undefined ||
			(this.selectedCompany == undefined &&
				!this.includesReport([
					this.enums.USAGE_REPORT,
					this.enums.COMPANY_SUMMARY_REPORT,
					this.enums.OFFICE_CASH_REPORT,
					this.enums.CHARGES_BALANCE_SUMMARY,
					this.enums.STAMP_HQ_SUMMARY
				]))
		) {
			this.sharedService.openAlert('Please select report type and company!', ALERT_TYPE.DANGER);
			return false;
		} else return true;
	}

	generateReport() {
		// if (this.selectedReport == undefined || this.selectedCompany == undefined)
		//   this.sharedService.openAlert("Please select report type and company!");
		if (this.checkPass() == false) {
		} else {
			//IF NOT PRIMARY REPORT
			if (this.selectedReport > 5) {
				if (this.selectedReport == this.enums.ASSET_SUMMARY_REPORT)
					this.router.navigate(['/assetSummary', this.selectedCompanyGroup, this.startDate.toISOString(), this.endDate.toISOString()]);
				else if (this.selectedReport == this.enums.EXTRA_REPORT)
					this.router.navigate(['/duitLebihReport', this.selectedCompany, this.startDate.toISOString(), this.endDate.toISOString()]);
				else if (this.isAll == true) this.router.navigate(['/simpleReport', this.selectedCompany, this.selectedReport]);
				else if (this.selectedReport == this.enums.MIDMONTH_REPORT) this.router.navigate(['/midMonth', this.selectedCompany]);
				else if (this.selectedReport == this.enums.USAGE_REPORT) this.router.navigate(['/usageReport']);
				else if (this.selectedReport == this.enums.FORMJ_REPORT) this.router.navigate(['/formJReport', this.selectedCompany]);
				else if (this.selectedReport == this.enums.OVERDUE_EPF_REPORT) this.router.navigate(['/overdueEPFReport', this.selectedCompany]);
				else if (this.selectedReport == this.enums.COMPANY_SUMMARY_REPORT)
					this.router.navigate(['/companiesSummaryReport', this.selectedCompanyGroup, this.startDate.toISOString()]);
				else if (this.selectedReport == this.enums.OFFICE_CASH_REPORT) this.router.navigate(['/officeCashReport', this.selectedCompanyGroup, this.startDate.toISOString()]);
				else if (this.selectedReport == this.enums.CHARGES_BALANCE_SUMMARY)
					this.router.navigate(['/chargesBalanceSummary', this.selectedCompanyGroup], {
						queryParams: { companyId: this.selectedCompany, endDate: !this.sharedService.checkIfDateIsToday(this.endDate) ? this.endDate.toISOString() : null },
						queryParamsHandling: 'merge',
						replaceUrl: true
					});
				else if (this.selectedReport == this.enums.STAMP_HQ_SUMMARY)
					this.router.navigate(['/stamphqSumamry', this.selectedCompanyGroup, this.startDate.toISOString(), this.endDate.toISOString()]);
				else this.router.navigate(['/simpleReport', this.selectedCompany, this.selectedReport, this.startDate.toISOString(), this.endDate.toISOString()]);
			}

			// PRIMARY REPORTS
			else if (this.selectedReport == this.enums.CASH_BOOK) {
				if (this.isAll == true) this.router.navigate(['/cashBookReport', this.selectedCompany]);
				else this.router.navigate(['/cashBookReport', this.selectedCompany, this.startDate.toISOString(), this.endDate.toISOString()]);
			} else if (this.selectedReport == this.enums.STOCK) {
				if (this.isAll == true) this.router.navigate(['/stockReport', this.selectedCompany]);
				else this.router.navigate(['/stockReport', this.selectedCompany, this.startDate.toISOString(), this.endDate.toISOString()]);
			} else if (this.selectedReport == this.enums.LIST_HUTANG) this.router.navigate(['/listHutang', this.selectedCompany, this.endDate.toISOString()]);
			else if (this.selectedReport == this.enums.DAILY_REPORT) this.router.navigate(['/dailyReport', this.selectedCompany, this.startDate.toISOString()]);
			else if (this.selectedReport == this.enums.CUSTOMER_RECORD_REPORT) this.router.navigate(['/customerRecord', this.selectedCompany]);
		}
		// this.outputToParent();
	}

	getMinDateForEndDate() {
		if (!this.includesReport([this.enums.LIST_HUTANG, this.enums.STOCK, this.enums.CHARGES_BALANCE_SUMMARY])) return this.startDate;
		else return null;
	}

	isDownloadTypeReport() {
		return this.enums.dlFileTypeReport.includes(Number(this.selectedReport));
	}

	async downloadEPFCustomersExcel() {
		const report = await this.getEPFCustomerExcel();
		this.fileService.downloadFile(report);
		this.disabledSubmitDL = false;
	}

	getEPFCustomerExcel() {
		const url = this.constructApi.getEPFCustomerExcelReport();
		return this.fileService.getFileByUrl(url);
	}

	downloadReport() {
		switch (Number(this.selectedReport)) {
			case this.enums.EPF_EXCEL_REPORT:
				this.disabledSubmitDL = true;
				this.downloadEPFCustomersExcel();
				break;
		}
	}
}
